
import { mapGetters } from 'vuex'
import authMixin from '@/mixins/auth'
import Breadcrumb from '@/components/Breadcrumb'
import ProductTable from '@/components/cart/ProductTable'
import PaymentInfo from '@/components/cart/PaymentInfo'
import EmptyCart from '@/components/cart/EmptyCart'

export default {
  layout: 'cart',
  components: {
    Breadcrumb,
    ProductTable,
    PaymentInfo,
    EmptyCart,
  },
  mixins: [authMixin],
  data() {
    return {
      current_step: 1,
    }
  },
  computed: {
    ...mapGetters({
      products: 'cart/list',
      normalizeProducts: 'cart/normalizeList',
    }),
    isEmpty() {
      return this.normalizeProducts.length === 0
    },
    breadcrumb() {
      return [
        {
          text: this.$t('route.home'),
          href: this.localePath('/'),
        },
        {
          text: this.$t('route.cart'),
        },
      ]
    },
    steps() {
      return [
        {
          label: this.$t('car.confirm_product'),
        },
        {
          label: this.$t('car.delivery_and_payment'),
        },
        {
          label: this.$t('car.order_complete'),
        },
      ]
    },
  },
  methods: {
    /**
     * @description: To payment page.
     * @param {*}
     * @return {*}
     */
    toPaymentPage() {
      if (this.isLogin) {
        if (!this.isEmailVerified) {
          return this.$bvModal.show('VerifyEmail')
        } else {
          return this.$router.push(this.localePath('/payment'))
        }
      }
      this.$toast.error(this.$t('toast.no_logged_in'))
      // show AuthModal
      this.$bvModal.show('Login')
    },
  },
}
